import axios from 'axios'
import { until } from '@vueuse/core'

import type { WebappMission } from '@/types/types'

export default function useWebappMissions() {
  const missions = ref<WebappMission[]>([])
  const isLoadingMissions = ref(false)
  const missionsError = ref(false)
  const { flags, pending: flagsPending } = useFeatureFlag()

  const isAllowedByFlags = (mission: WebappMission): boolean => {
    if (mission.type === 'loyalty_import') return flags.value['loyalty-card-merge']?.enabled === true

    return true
  }

  const getMissions = async (webappId: number) => {
    isLoadingMissions.value = true
    missionsError.value = false
    try {
      const [{ data }] = await Promise.all([
        axios.get(`/webapps/${webappId}/missions`),
        until(flagsPending).toBe(false, { timeout: 5000 })
      ])
      missions.value = (data.data as WebappMission[]).filter(isAllowedByFlags)
    } catch (error) {
      missionsError.value = true
      console.error(error)
    } finally {
      isLoadingMissions.value = false
    }
  }

  const saveMissions = async (webappId: number) => {
    const { data } = await axios.put(`/webapps/${webappId}/missions`, {
      missions: missions.value.map((mission, index) => ({ ...mission, order: index }))
    })
    missions.value = (data.data as WebappMission[]).filter(isAllowedByFlags)

    return missions.value
  }

  return { missions, isLoadingMissions, missionsError, getMissions, saveMissions }
}
